import type { SuggestionRow } from "./use-article-suggestions"

// The suggestion to land on after clearing `currentKey`. Prefers the next row
// in the sidebar order, falling back to the previous one so accepting the last
// suggestion keeps the user in the review flow rather than bouncing to the
// docs home. Returns null only when no other suggestion remains.
export function nextSuggestionRow(
	rows: SuggestionRow[],
	currentKey: string,
): SuggestionRow | null {
	const i = rows.findIndex((r) => r.key === currentKey)
	if (i === -1) return rows[0] ?? null
	return rows[i + 1] ?? rows[i - 1] ?? null
}

export function reviewRouteForRow(row: SuggestionRow): string {
	if (row.articleId) return `/edit-docs/review/${row.articleId}`
	const first = row.proposals[0]
	return first ? `/edit-docs/review-new/${first.id}` : "/edit-docs"
}
